#!/usr/bin/env node

import { LLMail } from '../LLMail.js';
import { realFileSystemAdapter } from '../utils/file-system-adapter.js';
import { loadLlmailConfig } from '../utils/config.js';
import { logger } from '../utils/logger.js';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';

async function main() {
  const argv = yargs(hideBin(process.argv))
    .usage('Usage: $0 sync [options]')
    .option('dry-run', {
      alias: 'd',
      type: 'boolean',
      description: 'Preview changes without applying them'
    })
    .option('force', {
      alias: 'f',
      type: 'boolean',
      description: 'Force sync without confirmation'
    })
    .help()
    .parseSync();

  const fsAdapter = realFileSystemAdapter;
  const rootDir = process.cwd();
  const configPath = argv.config as string | undefined;

  try {
    const config = await loadLlmailConfig(fsAdapter, rootDir, configPath);
    const llmail = new LLMail({ fs: fsAdapter, config });
    await llmail.init();

    const options: any = {};
    if (argv['dry-run']) {
      options.dryRun = true;
    }
    if (argv.force) {
      options.force = true;
    }

    const result = await llmail.sync(options);
    logger.success('Sync completed successfully.');

    if (result.changes && result.changes.length > 0) {
      logger.info('Changes:');
      result.changes.forEach(change => {
        logger.info(`ID: ${change.id}, from: ${change.from}, to: ${change.to}, state: ${change.state}`);
      });
    } else {
      logger.info('No changes detected.');
    }
    if (result && result.errors && result.errors.length > 0) {
      console.error('Errors:');
      result.errors.forEach(err => {
        console.error(`ID: ${err.id}, error: ${err.error}`);
      });
    }
  } catch (error) {
    console.error('Error during sync:', error);
    process.exit(1);
  }
}

main(); 